import { render } from "./CreateProjectView.vue?vue&type=template&id=7d8f58b2&scoped=true"
import script from "./CreateProjectView.vue?vue&type=script&lang=js"
export * from "./CreateProjectView.vue?vue&type=script&lang=js"

import "./CreateProjectView.vue?vue&type=style&index=0&id=7d8f58b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d8f58b2"]])

export default __exports__